/**
 * Config Management English Language Pack
 */

export default {
  title: 'Basic Config',
  search: {
    configName: 'Config Name',
    remarks: 'Remarks',
    search: 'Search',
    reset: 'Reset',
    placeholder: {
      enterConfigName: 'Enter config name',
      enterRemarks: 'Enter remarks'
    }
  },
  actions: {
    addConfig: 'Add Config',
    batchDelete: 'Batch Delete',
    totalRecords: 'Total {count} records'
  },
  table: {
    columns: {
      configName: 'Config Name',
      configValue: 'Default Value',
      currentValue: 'Current Value',
      dataType: 'Data Type',
      overrideable: 'Overrideable',
      literals: 'Literals',
      remarks: 'Remarks',
      actions: 'Actions'
    },
    actions: {
      detail: 'Detail',
      edit: 'Edit',
      setValue: 'Set Value',
      reset: 'Reset'
    }
  },
  modal: {
    title: {
      add: 'Add Config Definition',
      edit: 'Edit Config Definition',
      detail: 'Config Definition Detail',
      value: 'Config Value Detail',
      editValue: 'Edit Config Value'
    },
    form: {
      configName: 'Config Name',
      configValue: 'Config Value',
      defaultValue: 'Default Value',
      currentValue: 'Current Value',
      dataType: 'Data Type',
      overrideable: 'Overrideable',
      literals: 'Literals',
      remarks: 'Remarks',
      placeholder: {
        enterConfigName: 'Enter config name',
        enterConfigValue: 'Enter config value',
        enterDefaultValue: 'Enter default value',
        selectDataType: 'Select data type',
        enterLiterals: 'Enter literals list',
        enterRemarks: 'Enter remarks'
      }
    },
    okText: 'OK',
    cancelText: 'Cancel'
  },
  message: {
    success: {
      create: 'Config definition created successfully',
      update: 'Config definition updated successfully',
      updateValue: 'Config value updated successfully',
      createValue: 'Config value created successfully',
      delete: 'Config definition deleted successfully',
      batchDelete: 'Batch delete successful, {count} records deleted',
      reset: 'Config value reset successfully'
    },
    error: {
      createFailed: 'Failed to create config definition',
      updateFailed: 'Failed to update config definition',
      updateValueFailed: 'Failed to update config value',
      createValueFailed: 'Failed to create config value',
      deleteFailed: 'Failed to delete config definition',
      batchDeleteFailed: 'Batch delete failed',
      loadFailed: 'Failed to load data',
      operationFailed: 'Operation failed',
      configNameExists: 'Config name already exists',
      resetFailed: 'Failed to reset config value'
    },
    info: {
      noConfigDetailToReset: 'No config detail record to reset'
    },
    warning: {
      noSelection: 'Please select records to delete',
      noConfigId: 'Config ID does not exist'
    }
  },
  confirm: {
    delete: {
      title: 'Confirm Delete',
      content: 'Are you sure to delete config definition "{name}"?',
      batchContent: 'Are you sure to delete {count} selected config definitions?',
      okText: 'OK',
      cancelText: 'Cancel'
    },
    reset: {
      title: 'Confirm Reset',
      content: 'Are you sure to reset config "{name}" value? This will reset the current tenant\'s config to default value.',
      okText: 'OK',
      cancelText: 'Cancel'
    }
  },
  dataType: {
    string: 'String',
    number: 'Number',
    boolean: 'Boolean'
  },
  tag: {
    yes: 'Yes',
    no: 'No'
  }
}
